// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CurrencyYenIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CurrencyYen/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7.858 5.485a1 1 0 1 0-1.715 1.03L7.634 9H7a1 1 0 1 0 0 2h1.834l.166.277V12H7a1 1 0 1 0 0 2h2v1a1 1 0 0 0 2 0v-1h2a1 1 0 0 0 0-2h-2v-.723l.166-.277H13a1 1 0 0 0 0-2h-.634l1.492-2.486a1 1 0 1 0-1.715-1.029L10.034 9h-.068L7.858 5.485Z",
  clipRule: "evenodd"
}));
export default CurrencyYenIcon;